const dataWebpackPrefix = "buy:";

function getDataWebpackId(identifier) {
	return dataWebpackPrefix + identifier;
}

function findStyleElement(identifier) {
	const elements = document.getElementsByTagName('style');
	for (var i = 0; i < elements.length; i++) {
		const el = elements[i];
		if (el.getAttribute('data-webpack') === getDataWebpackId(identifier)) {
			return el;
		}
	}
	return null;
}

function insertStyleElement(key) {
	const style = document.createElement('style');

	if (__webpack_require__.nc) {
		style.setAttribute("nonce", __webpack_require__.nc);
	}
	style.setAttribute("data-webpack", getDataWebpackId(key));

	document.head.appendChild(style);

	return style;
}

__webpack_require__.is = (identifier, css) => {
	const element = findStyleElement(identifier) || insertStyleElement(identifier);
	element.textContent = css;
};

// no css inject style HMR download handler